import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import ReviewWidget from "@/components/ReviewWidget";
import ServiceAreas from "@/components/ServiceAreas";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { faqs } from "@/lib/faq-data";
import { siteConfig } from "@/lib/site-config";

const Index = () => {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  const businessJsonLd = {
    "@context": "https://schema.org",
    "@type": "GeneralContractor",
    name: siteConfig.name,
    image: `${siteConfig.url}${siteConfig.ogImage}`,
    logo: `${siteConfig.url}${siteConfig.logo}`,
    url: siteConfig.url,
    telephone: "+16784311203",
    email: siteConfig.email,
    founder: { "@type": "Person", name: siteConfig.owner },
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: siteConfig.address.street,
      addressLocality: siteConfig.address.city,
      addressRegion: siteConfig.address.state,
      postalCode: siteConfig.address.postalCode,
      addressCountry: siteConfig.address.country,
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: siteConfig.hours.daysOfWeek,
      opens: siteConfig.hours.opens,
      closes: siteConfig.hours.closes,
    },
    areaServed: siteConfig.serviceAreas,
    sameAs: [siteConfig.social.instagram].filter(Boolean),
  };

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="F&T Renovations | Remodeling & Painting in Lawrenceville, GA"
        description="Lawrenceville, GA remodeling and painting contractor — bathrooms, flooring, tile, decks, Sheetrock and more across metro Atlanta. Free estimates."
        path="/"
        jsonLd={[businessJsonLd, faqJsonLd]}
      />
      <TopBar />
      <Navbar />
      <main id="main-content" tabIndex={-1}>
        <HeroSection />
        <ServicesSection />
        <WhyChooseUs />
        <ReviewWidget />
        <ServiceAreas />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
